let AX_MAJOR: number = 0
let AX_FEATURE: number = 0
let AX_BUGFIXES: number = 0
let AX_ENV: string = ''

switch (process.env.REACT_APP_LOCAL_DB) {
  //Dont touch this part (local)
  case 'local':
    AX_MAJOR = 1
    AX_FEATURE = 0
    AX_BUGFIXES = 1
    AX_ENV = '-local'
    break
  //-------- Dev Lite / Staging Lite --------- //
  case 'azure':
  case 'dev':
  case 'staging':
    AX_MAJOR = 2
    AX_FEATURE = 49
    AX_BUGFIXES = 3
    break
  //-------- Live Lite -------- //
  //ignore this because lite different branch
  case 'prod':
  case 'noble':
  case 'asia':
  case 'promenade':
  case 'training':
  case 'demo':
  case 'promenade-uat':
    AX_MAJOR = 1
    AX_FEATURE = 3
    AX_BUGFIXES = 22
    break

  //----- Dev Ent / Ent UAT / Ent Train ------ //
  case 'ent-dev':
  case 'ent-uat':
    AX_MAJOR = 2
    AX_FEATURE = 69
    AX_BUGFIXES = 2
    break
  //------ Dev Internal ------- //
  case 'axifcadev':
    AX_MAJOR = 2
    AX_FEATURE = 29
    AX_BUGFIXES = 15
    break
  //------ Live Internal ------- //
  case 'internal':
    AX_MAJOR = 2
    AX_FEATURE = 29
    AX_BUGFIXES = 15
    break
  //------ Live Ent 1 / Live Ent 2 / Live AX PX / Ent Train ------- //
  case 'prod-ent2':
  case 'prod-ent':
  case 'prod-ax-px':
  case 'ent-train':
  case 'trial-migration':
    AX_MAJOR = 1
    AX_FEATURE = 30
    AX_BUGFIXES = 11
    break
  default:
    AX_MAJOR = 1
    AX_FEATURE = 0
    AX_BUGFIXES = 1
    break
}

export const APP_VERSION = `v${AX_MAJOR}.${AX_FEATURE}.${AX_BUGFIXES}${AX_ENV}`
